import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SnackbarProvider } from 'notistack';
import { InAppBrowserGuard } from '@repo/ui';

import './lib/i18n';

import { ReactNode, Suspense, useEffect } from 'react';
import { LoaderProvider } from './contexts/LoaderContext';
import { useTranslation } from 'react-i18next';

function App({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback='Loading...'>
      <SnackbarProvider maxSnack={3}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <LoaderProvider>
            <LanguageInitializer />
            <InAppBrowserGuard>
              {children}
            </InAppBrowserGuard>
          </LoaderProvider>
        </LocalizationProvider>
      </SnackbarProvider>
    </Suspense>
  );
}

// Component to set the HTML lang attribute on mount and when language changes
function LanguageInitializer() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return null;
}

export default App;
